import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="bg-kitchen-white py-12 md:py-20 px-5 md:px-12 lg:px-24" data-id="element-112">
      <div className="max-w-3xl mx-auto" data-id="element-113">
        <FadeIn data-id="element-114">
          <p className="font-nunito text-lg md:text-2xl text-kitchen-brown leading-relaxed mb-8 md:mb-12 italic border-l-4 border-kitchen-amber pl-5 md:pl-6" data-id="element-115">
            "Estás en tu cocina, miras la cuenta del banco y sientes ese nudo en
            el estómago. Sabes que el dinero de la semana no alcanza para la
            renta o los suministros de tus hijos. Te han dicho que sin 'papeles'
            o sin un auto para ir a limpiar casas lejos de tu zona no puedes
            progresar."
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-116">
          <p className="font-nunito text-base md:text-xl text-kitchen-brown mb-10 md:mb-16 leading-relaxed" data-id="element-117">
            Pero tienes una estufa, tienes sazón y tienes vecinos que tienen
            hambre todos los días a las 12:00 PM. Estás sentada sobre una mina
            de oro y este manual es la llave para activarla.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-118">
          <h2 className="font-lora text-2xl md:text-4xl font-bold text-kitchen-brown mb-5 md:mb-8 flex items-center gap-3" data-id="element-119">
            <span data-id="element-120">La Gran Mentira</span> <span className="text-2xl" data-id="element-121">🚫</span>
          </h2>
          <div className="space-y-4 md:space-y-6 font-nunito text-base md:text-lg text-kitchen-brown/90" data-id="element-122">
            <p data-id="element-123">
              Muchos creen que para vender comida en Estados Unidos necesitas
              miles de dólares en permisos, un local físico o un vehículo para
              hacer entregas. Esa mentira hace que te quedes paralizada en casa
              mientras las facturas siguen llegando.
            </p>
            <p className="bg-kitchen-cream p-4 md:p-6 rounded-xl border border-kitchen-amber/20" data-id="element-124">
              El miedo a perder el poco dinero que tienes comprando comida que
              "nadie compre" es real. Has intentado vender cosas antes, pero sin
              un sistema, terminas regalando tu trabajo o comiéndote la
              inversión por falta de organización.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}